module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"click":"клик","double":"двойной"}}')
  delete Component.options._Ctor
}
